/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSchedule} from '../api'

 export const useQueryGetSchedule = createReactQueryHook('getSchedule', getSchedule)
